import { DSTreeObject } from '../types';
import { addOidHistory } from './addOidHistory';

export const removeDuplicatedSimulations = (
	simulations: DSTreeObject[],
): DSTreeObject[] => {
	const filteredSimulations: DSTreeObject[] = [];

	simulations.forEach(simulation => {
		const existingSimulation = filteredSimulations.find(
			({ oname }) => oname === simulation.oname,
		);

		if (existingSimulation) {
			if (simulation.crtime > existingSimulation.crtime) {
				const index = filteredSimulations
					.map(({ oname }) => oname)
					.indexOf(existingSimulation.oname);
				filteredSimulations[index] = simulation;
			}

			return;
		}
		filteredSimulations.push(simulation);
	});

	return addOidHistory(filteredSimulations, simulations);
};
